// src/routes/index.jsx
import { createBrowserRouter, Navigate } from 'react-router-dom';

import App from '../App';
import Home from '../pages/Home';
import CharacterDesigner from '../pages/CharacterDesigner';
import WorldExplorer from '../pages/WorldExplorer';
import OntologyEditor from '../pages/OntologyEditor';
import RuleManager from '../pages/RuleManager';
import ServicesTester from '../pages/ServicesTester';
import GameClient from '../pages/GameClient';
import Cabinet from '../pages/Cabinet';
import Profile from '../pages/Profile';
import UserManagement from '../pages/admin/UserManagement';
import KratosIdentities from '../pages/admin/KratosIdentities';
import AssetManager from '../pages/AssetManager';

import ProtectedRoute from '../components/auth/ProtectedRoute';
import RequireResource, { RequireRole } from '../components/auth/RequireResource';
import { GameSessionProvider } from '../components/game_client/GameSessionContext';
import GameLayout from '../components/game_client/GameLayout';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      { index: true, element: <Home /> },

      // 🔒 Тестер сервисов — только admin/superadmin
      {
        path: 'services',
        element: (
          <ProtectedRoute>
            <RequireRole roles={['admin', 'superadmin']}>
              <ServicesTester />
            </RequireRole>
          </ProtectedRoute>
        ),
      },

      { path: 'designer', element: <ProtectedRoute><CharacterDesigner /></ProtectedRoute> },
      { path: 'worlds', element: <ProtectedRoute><WorldExplorer /></ProtectedRoute> },
      { path: 'profile', element: <ProtectedRoute><Profile /></ProtectedRoute> },

      {
        path: 'assets',
        element: (
          <ProtectedRoute>
            <RequireResource resource="assets">
              <AssetManager />
            </RequireResource>
          </ProtectedRoute>
        ),
      },

      // 👁️ Онтологии — доступны всем авторизованным (только просмотр для не-админа)
      {
        path: 'ontologys',
        element: (
          <ProtectedRoute>
            <OntologyEditor />
          </ProtectedRoute>
        ),
      },

      // 👁️ Правила — доступны всем авторизованным (только просмотр для не-админа)
      {
        path: 'rules',
        element: (
          <ProtectedRoute>
            <RuleManager />
          </ProtectedRoute>
        ),
      },

      {
        path: 'admin/users',
        element: (
          <ProtectedRoute>
            <RequireResource resource="users">
              <UserManagement />
            </RequireResource>
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin/kratos',
        element: (
          <ProtectedRoute>
            <RequireResource resource="users">
              <KratosIdentities />
            </RequireResource>
          </ProtectedRoute>
        ),
      },

      {
        path: 'game',
        element: (
          <ProtectedRoute>
            <GameSessionProvider>
              <GameLayout />
            </GameSessionProvider>
          </ProtectedRoute>
        ),
        children: [
          { index: true, element: <Navigate to="cabinet" replace /> },
          { path: 'cabinet', element: <Cabinet /> },
          { path: 'world', element: <GameClient /> },
        ],
      },

      { path: '*', element: <Navigate to="/" replace /> },
    ],
  },
]);
